import { LegacyNotificationList } from '../LegacyNotificationList';

export const LegacyNotificationListPage: React.FC = () => {
  return <LegacyNotificationList isPage={true} hasBorder={true} />;
};
